module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.vendorsIni != 0) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.vendorsIni != 0) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.vendorManufacturerLinks,
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "50%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "25%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Reference / Account Number",
            "single-line": "",
            "solo": ""
          },
          on: {
            "keyup": function($event) {
              return _vm.fncCheck($event.target.value, props.index, 'reference')
            }
          },
          model: {
            value: (props.item.setReference),
            callback: function($$v) {
              _vm.$set(props.item, "setReference", $$v)
            },
            expression: "props.item.setReference"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "25%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Email Address Override",
            "single-line": "",
            "solo": ""
          },
          on: {
            "keyup": function($event) {
              return _vm.fncCheck($event.target.value, props.index, 'email')
            }
          },
          model: {
            value: (props.item.email),
            callback: function($$v) {
              _vm.$set(props.item, "email", $$v)
            },
            expression: "props.item.email"
          }
        })], 1)]
      }
    }], null, false, 2398685465)
  }) : _vm._e(), _vm._v(" "), (_vm.vendorsIni == 0) ? _c('p', [_vm._v("Please initiate the Vendors for this MyOrder Instance")]) : _vm._e(), _vm._v(" "), (_vm.vendorsIni == 0) ? _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncIniVendors.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v("Initiate Vendors")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}